var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.$router.currentRoute.path !== '/login')?_c('v-header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(_vm.$router.currentRoute.path !== '/login')?_c('v-add-potentials'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }